import { runningVersion, type TenantView, type VersionStatus } from '@teachpartner/contracts';
import { UpdateNoticeNote } from './update-notice';

const NOT_REPORTED = 'No version reported yet';

/** Placeholder for a missing value: a dash on screen, words for screen readers. */
export function Unknown({ label }: { label: string }) {
  return (
    <>
      <span aria-hidden="true" title={label}>
        —
      </span>
      <span className="sr-only">{label}</span>
    </>
  );
}

/** Where a school stands against the latest release; nothing when unknown. */
export function VersionStatusBadge({
  status,
  latest,
}: {
  status: VersionStatus;
  latest: string | null;
}) {
  const title = latest ? `Latest release is ${latest}` : undefined;
  switch (status) {
    case 'outdated':
      return (
        <span className="badge badge-warn" title={title}>
          Outdated
        </span>
      );
    case 'current':
      return (
        <span className="badge badge-ok" title={title}>
          Up to date
        </span>
      );
    case 'ahead':
      return (
        <span className="badge badge-info" title={title}>
          Newer than latest
        </span>
      );
    default:
      return null;
  }
}

/** Tenant list cell: running version (release, else tenant-api), an Outdated flag and the update email note. */
export function VersionCell({ tenant }: { tenant: TenantView }) {
  const running = runningVersion(tenant.versions);
  if (!running) return <Unknown label={NOT_REPORTED} />;
  return (
    <>
      <span>{running}</span>
      {tenant.versionStatus === 'outdated' && (
        <>
          {' '}
          <VersionStatusBadge status="outdated" latest={tenant.latestRelease} />
        </>
      )}
      {tenant.updateNotice && (
        <>
          {' '}
          <UpdateNoticeNote notice={tenant.updateNotice} />
        </>
      )}
    </>
  );
}
